class CountryOfResidenceController {
  constructor ($scope, CountriesService, Localization, $log, I18n, $filter) {
    'ngInject'
    this.countriesService = CountriesService
    this.I18n = I18n
    this.$log = $log
    this.countries = []
    this.getCountries()
    $scope.translateCountry = function (p) {
      return $filter('translate')('countries.' + p)
    }
  }

  getCountries () {
    return this.countriesService.getCountries()
    .then((res) => {
      this.error = null
      this.countries = JSON.parse(res)
    }, (err) => {
      this.$log.error('getCountries error', err)
      this.error = err
    })
  }
}

export default CountryOfResidenceController



// WEBPACK FOOTER //
// ./src/app/pages/manage-purchase/my-purchase/buy-product/country-of-residence/country-of-residence.controller.js